import { Box, Skeleton, Typography } from '@mui/material';
import { MainContainer, MainHeading, ParaText } from '../../style/GlobalStyles';
import DocumentCardSkeleton from '../../components/DocumentCard/skeleton';

export const skeleton = (
    <>
        <MainContainer>
            <MainHeading>
                <Skeleton variant="text" sx={{ width: { xs: '30%', sm: '20%' } }} />
            </MainHeading>
            <ParaText>
                <Skeleton variant="text" width="100%" />
                <Skeleton variant="text" width="100%" />
            </ParaText>

            {Array.from(Array(6).keys()).map((key) => (
                <Box key={key} marginTop={'3rem'}>
                    <Typography component={'h2'} fontSize={'customFontSize.xLarge'} lineHeight={'140%'} marginBottom={'1rem'}>
                        <Skeleton variant="text" sx={{ width: { xs: '30%', sm: '20%' } }} />
                    </Typography>
                    <Box display={'flex'} flexWrap={'wrap'} marginLeft={'-0.5rem'}>
                        {Array.from(Array(6).keys())?.map((cDoc) => (
                            <DocumentCardSkeleton key={cDoc} />
                        ))}
                    </Box>
                </Box>
            ))}
        </MainContainer>
    </>
);
